import Component from '@bythepixel/component-loader';

/**
 * data-comp-accordion can be applied to accordions where only one accordion is open at a time
 */
export default class Accordion extends Component {
  static selector = '[data-comp-accordion]';

  constructor(containerEl) {
    super(containerEl);

    this.accordionGroups = this.$container.querySelectorAll(
      '[data-comp-accordion-group]',
    );
    this.accordionTriggers = this.$container.querySelectorAll(
      '[data-comp-accordion-group-trigger]',
    );

    this.initializeListeners();
  }

  initializeListeners() {
    this.accordionTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => this.clickEvent(index));
    });
  }

  clickEvent(index) {
    this.accordionGroups.forEach((accordionGroup, accordionIndex) => {
      if (index !== accordionIndex) {
        accordionGroup.removeAttribute('open');
      }
    });
  }
}
